module.exports = __webpack_public_path__ + "img/e7e6016.png";